/* eslint-disable import/no-anonymous-default-export */
import React, { ReactNode, useMemo, useState } from 'react';
import {
    mediaGalleryGridStyle,
    mediaGalleryStyle,
    mediaGallerySubstageStyle,
    substageMediaGalleryStyle,
    mediaGalletyGridDarkStyle
} from './styles/MediaGallery.styles';
import { RemoteParticipant, LocalVideoStream } from '@azure/communication-calling';
import {
    IsHiddenMode,
    utils,
    IsInterlocutorMode,
    ChatCommunicationIdentifierId,
    IsCandidateMode,
    IsProctorMode,
    IsCentralScreenMode,
    IsSecondaryStreamUser,
    ShouldUserBeVisible,
    ShouldShowLabel,
    IsProctorCameraEnabled
} from '../Utils/Utils';
import LocalStreamMedia from './LocalStreamMedia';
import RemoteStreamMedia from './RemoteStreamMedia';
import { SelectionState } from 'core/RemoteStreamSelector';
import { CommandButton, Label, Stack } from '@fluentui/react';
import { Constants, URLOptionsConstants, labelConstants } from '../core/constants';
import { MediaControlsContainer, videoHint } from './styles/StreamMedia.styles';
import { Icon } from '@iconify/react';
import {
    containericon,
    containerControlButtonStyle,
    containerControlButtonDisabledStyle
} from './styles/MediaControls.styles';
import {
    toggleCandidateMicrophone,
    toggleCandidateCamera,
    triggerVolumeUp,
    triggerVolumeDown,
    toggleCandidateScreenSharing,
    requestCandidateSettings,
    GetUserLocalSettingsProps,
    refreshCandidatePage
} from '../core/sideEffects';

import {
    footerStyle,
    labelFooterStyle
} from './styles/GroupCall.styles';

import { IRemoteLocalSettingsProps } from './RemoteLocalSettings';
import RemoteCommandPanel from './RemoteCommandPanel';
export interface MediaGalleryProps {
    userId: string;
    displayName: string;
    remoteParticipants: RemoteParticipant[];
    localVideoStream: LocalVideoStream;
    dominantParticipants: SelectionState[];
    localPreview: boolean;
}

let remoteprops: Array<IRemoteLocalSettingsProps> = [];
let timeout: number = 4000;
let isWaiting = true;
let SelectedCandidate = false;
let selectedCandidateProps: IRemoteLocalSettingsProps;
const setLoading = (value: boolean) => {

    if (value)
        document.body.style.cursor = 'wait';
    else
        document.body.style.cursor = 'default';

};

const MediaControlButtons = (userid: string, isMuted: boolean, isStreamAvailable: boolean,
    setDisabled: any, disabled: boolean,
    setScreenShareActive: any, isScreenShareActive: boolean,
    setSettingsActive: any, isSettingsActive: boolean, setSelectedCandidate: any, selectedCandidate: string,
    setCameraActive: any, isCameraActive: boolean, displayname: string | undefined): ReactNode => {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const threadId = urlParams.get(URLOptionsConstants.THREADID);
    const isSecondaryStream = IsSecondaryStreamUser(displayname);
    const controlUserId = userid;
    let Props: IRemoteLocalSettingsProps | undefined;

    const IsSelectedCandidate = () => {
        let res = false;
        if (controlUserId === selectedCandidate) {
            res = true;
            SelectedCandidate = true;
        }
        else {
            SelectedCandidate = false;

        }
        return res;
    };

    if (isStreamAvailable)
        isCameraActive = true;
    else
        isCameraActive = false;

   

    return (
        <div>
            <div className={containericon}>
                {(IsInterlocutorMode() || IsProctorMode()) && (
                    <CommandButton
                        id={"toggleSettings" + userid}
                        disabled={disabled}
                        onClick={() => {
                            SelectedCandidate = false;

                            if (isSettingsActive && IsSelectedCandidate()) {
                                setSelectedCandidate('');
                                setSettingsActive(false);
                                isSettingsActive = false;
                            }
                            else {
                                Props = GetUserLocalSettingsProps(userid);

                                if (Props) {
                                    if (!remoteprops.find(c => c.userId === userid))
                                        remoteprops.push(Props);

                                    selectedCandidateProps = Props;
                                    setSettingsActive(true);
                                    isSettingsActive = true;
                                    SelectedCandidate = true;
                                    selectedCandidate = userid;
                                    setSelectedCandidate(selectedCandidate);
                                }
                                else {

                                    setLoading(true);
                                    requestCandidateSettings(threadId, userid);

                                    setTimeout(function () {
                                        Props = GetUserLocalSettingsProps(userid);
                                        if (Props) {
                                            if (!remoteprops.find(c => c.userId === userid))
                                                remoteprops.push(Props);

                                            selectedCandidateProps = Props;
                                            setSettingsActive(true);
                                            isSettingsActive = true;
                                            SelectedCandidate = true;
                                            selectedCandidate = userid;
                                            setSelectedCandidate(selectedCandidate);
                                            setLoading(false);
                                        }
                                        else {
                                            setLoading(false);
                                        }
                                    }, timeout);
                                    timeout = (timeout === 1000 ? 100 : 4000);
                                }
                            }
                        }}
                        className={!SelectedCandidate ? containerControlButtonStyle : containerControlButtonDisabledStyle}

                    >
                        <div>
                            <Icon icon="ph:gear-six-fill" color={IsSelectedCandidate() ? "#808080" : "#ff3200"} width="16" height="16" />
                        </div>
                    </CommandButton>
                )}

                {!IsSelectedCandidate() && !isSecondaryStream && (IsInterlocutorMode() || IsProctorMode()) && (
                    <CommandButton
                        id={"toggleScreenShare"}
                        disabled={disabled}
                        onClick={() => {
                            toggleCandidateScreenSharing(threadId, userid);
                            setScreenShareActive(true);
                            setTimeout(function () {
                                setScreenShareActive(false);
                            }, 2000);
                        }}
                        className={isScreenShareActive ? containerControlButtonStyle : containerControlButtonDisabledStyle}
                    >
                        <div>

                            <Icon icon="fluent:share-screen-start-20-filled" color={IsSelectedCandidate() ? "#808080" : "#ff3200"} width="16" height="16" />

                        </div>
                    </CommandButton>
                )}

                {!IsSelectedCandidate() && (IsInterlocutorMode() || (IsProctorMode() && !IsProctorCameraEnabled())) && (
                    <CommandButton
                        id={"toggleCandidateCamera"}
                        disabled={disabled}
                        onClick={() => {
                            toggleCandidateCamera(threadId, userid);
                            setCameraActive(isCameraActive);
                            setTimeout(function () {                              
                                setCameraActive(isCameraActive);
                            }, 2000);
                        }}
                        className={isCameraActive ? containerControlButtonStyle : containerControlButtonDisabledStyle}
                    >
                        <div>
                            {isCameraActive ?
                                <Icon icon="bi:camera-video-fill" color="#ff3200" width="16" height="16" /> :
                                <Icon icon="bi:camera-video-off-fill" color="#ff3200" width="16" height="16" />
                            }

                        </div>
                    </CommandButton>
                )}
                {!IsSelectedCandidate() && (IsInterlocutorMode() || IsProctorMode()) && isSecondaryStream && (
                    <CommandButton
                        id={"RefreshCandidatepage"}
                        disabled={disabled}
                        onClick={() => {
                            setLoading(true);
                            refreshCandidatePage(threadId, userid);
                            setTimeout(function () {
                                setLoading(false);
                            }, 2000);
                        }}
                        className={containerControlButtonStyle}
                    >
                        <div>
                            <Icon icon="fa:refresh" color="#ff3200" width="16" height="16" />
                        </div>
                    </CommandButton>
                )}

                {!IsSelectedCandidate() && !isSecondaryStream && (IsInterlocutorMode() || IsProctorMode()) && (
                    <CommandButton
                        id={"muteVolume"}
                        disabled={disabled}
                        onClick={() => {
                            setDisabled(true);
                            toggleCandidateMicrophone(threadId, userid);
                            setTimeout(function () {
                                setDisabled(false);
                            }, 2000);
                        }}
                        className={!isMuted ? containerControlButtonDisabledStyle : containerControlButtonStyle} //containericon
                    >
                        <div>
                            {!isMuted ?
                                <Icon icon="clarity:microphone-solid" color="#ff3200" width="16" height="16" /> :
                                <Icon icon="clarity:microphone-mute-solid" color="#ff3200" width="16" height="16" />
                            }
                        </div>
                    </CommandButton>)
                }

                {!IsSelectedCandidate() && !isSecondaryStream && (IsInterlocutorMode() || IsProctorMode()) && (
                    <CommandButton
                        id={"VolumeUp"}
                        onClick={() => {
                            triggerVolumeUp(threadId, userid);
                            setDisabled(true);
                            setTimeout(function () {
                                setDisabled(false);
                            }, 2000);
                        }}
                        className={containerControlButtonStyle}
                    >
                        <div>
                            <Icon icon="mdi:microphone-plus" color="#ff3200" width="16" height="16" />
                        </div>
                    </CommandButton>
                )}

                {!IsSelectedCandidate() && !isSecondaryStream && (IsInterlocutorMode() || IsProctorMode()) && (
                    <CommandButton
                        id={"VolumeDown"}
                        onClick={() => {
                            triggerVolumeDown(threadId, userid);
                            setDisabled(true);
                            setTimeout(function () {
                                setDisabled(false);
                            }, 2000);
                        }}
                        className={containerControlButtonStyle}
                    >
                        <div>
                            <Icon icon="mdi:microphone-minus" color="#ff3200" width="16" height="16" />
                        </div>
                    </CommandButton>
                )}

            </div>

        </div >
    );
}

export default (props: MediaGalleryProps): JSX.Element => {
    const [gridCol, setGridCol] = useState(1);
    const [gridRow, setGridRow] = useState(1);

    // For now we are only going to support up to a 4x3 grid or 10 participants in a call
    // Since this is a sample, we will just hard-code how we want the grid to scale
    // the rows and columns for the number of users in the call
    const rows = [1, 2, 2, 2, 2, 2, 3, 3, 3, 3];
    const cols = [1, 1, 2, 2, 3, 3, 3, 3, 3, 4];

    const [disabled, setDisabled] = useState(false);
    const [isScreenShareActive, setIsScreenShareActive] = useState(false);
    const [isSettingsActive, setSettingsActive] = useState(false);
    const [isCameraActive, setCameraActive] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState('');

    const dominantParticipantCount = utils.isSafari()
        ? Constants.DOMINANT_PARTICIPANTS_COUNT_SAFARI
        : Constants.DOMINANT_PARTICIPANTS_COUNT;

    if (dominantParticipantCount < 0 || dominantParticipantCount > rows.length - 1) {
        console.warn(`Please use a value for dominant participants between 0 <= x <= ${rows.length - 1}`);
    }

    const numRemoteParticipantsToRender = Math.min(dominantParticipantCount, rows.length - 1);

    const clamp = (num: number, min: number, max: number): number => Math.min(Math.max(num, min), max);

    const getMediaGalleryTilesForParticipants = (
        participants: RemoteParticipant[],
        displayName: string
    ): JSX.Element[] => {
        if (props.remoteParticipants.length > 0) {
            isWaiting = false;
        }
        const remoteParticipantsMediaGalleryItems = participants.map((participant) => (

            <div key={`${utils.getId(participant.identifier)}-tile`} className={mediaGalleryStyle}>

                {(IsInterlocutorMode() || IsProctorMode()) &&
                    <div className={MediaControlsContainer}>
                        {MediaControlButtons(ChatCommunicationIdentifierId(participant.identifier), participant.isMuted, participant.videoStreams[0].isAvailable,
                            setDisabled, disabled, setIsScreenShareActive, isScreenShareActive, setSettingsActive, isSettingsActive, setSelectedCandidate, selectedCandidate, setCameraActive, isCameraActive, participant.displayName)}
                        <div>
                            {SelectedCandidate &&
                                <RemoteCommandPanel {...selectedCandidateProps} />
                            }
                        </div>
                    </div>

                }
                <RemoteStreamMedia
                    key={utils.getId(participant.identifier)}
                    stream={participant.videoStreams[0]}
                    isParticipantStreamSelected={
                        props.dominantParticipants.filter((p) => p.participantId === utils.getId(participant.identifier)).length > 0
                    }
                    label={participant.displayName ?? utils.getId(participant.identifier)}
                />
                {ShouldShowLabel(false, participant.displayName) &&
                    <div >
                        <Label className={videoHint}>{participant.displayName ?? utils.getId(participant.identifier)}</Label>

                    </div>
                }
            </div>
        ));

        if (props.localPreview && !IsHiddenMode() && !(IsProctorMode() && !IsProctorCameraEnabled())) {
            // for now we will always add the local user to the main stage
            const localParticipantMediaGalleryItem = (
                <div key="localParticipantTile" className={mediaGalleryStyle}>
                    <LocalStreamMedia label={utils.getUsernameFromLabel(displayName)} stream={props.localVideoStream} />
                </div>
            );
            remoteParticipantsMediaGalleryItems.unshift(localParticipantMediaGalleryItem);
        }

        return remoteParticipantsMediaGalleryItems;
    };

    const getSubstageMediaGalleryTilesForParticipants = (participants: RemoteParticipant[]): JSX.Element[] => {
        const remoteParticipantsMediaGalleryItems = participants.map((participant) => (
            <div key={`${utils.getId(participant.identifier)}-tile`} className={substageMediaGalleryStyle}>
                <div className={MediaControlsContainer}>
                    {MediaControlButtons(ChatCommunicationIdentifierId(participant.identifier), participant.isMuted, participant.videoStreams[0].isAvailable,
                        setDisabled, disabled, setIsScreenShareActive, isScreenShareActive, setSettingsActive, isSettingsActive, setSelectedCandidate, selectedCandidate, setCameraActive, isCameraActive, participant.displayName)}
                    <div>
                        {(SelectedCandidate) &&
                            (<RemoteCommandPanel {...selectedCandidateProps} />)
                        }
                    </div>
                </div>
                <RemoteStreamMedia
                    key={utils.getId(participant.identifier)}
                    stream={participant.videoStreams[0]}
                    isParticipantStreamSelected={false}
                    label={utils.getUsernameFromLabel(participant.displayName ?? utils.getId(participant.identifier))}
                />
            </div>
        ));

        return remoteParticipantsMediaGalleryItems;
    };

    // determine number of rows/columns to add to the grid
    const numberStreamsToRender = useMemo(
        () => clamp(props.remoteParticipants.filter((p) => ShouldUserBeVisible(p.displayName + "")).length - (IsHiddenMode() || (IsProctorMode() && !IsProctorCameraEnabled()) ? 1 : 0), 0, numRemoteParticipantsToRender),
        [numRemoteParticipantsToRender, props.remoteParticipants.filter((p) => ShouldUserBeVisible(p.displayName + "")).length, IsHiddenMode, IsProctorMode]
    );
    if (cols[numberStreamsToRender] !== gridCol) {
        if (numberStreamsToRender > cols.length - 1) {
            throw new Error(
                `attempting to set up a number of columns in the gallery for an unexpected number of participants ${numberStreamsToRender}`
            );
        }
        setGridCol(cols[numberStreamsToRender]);
    }

    if (rows[numberStreamsToRender] !== gridRow) {
        if (numberStreamsToRender > rows.length - 1) {
            throw new Error(
                `attempting to set up a number of rows in the gallery for an expected number of participants ${numberStreamsToRender}`
            );
        }
        setGridRow(rows[numberStreamsToRender]);
    }

    // sort by dominance
    const participantsToLayout = props.remoteParticipants.filter((p) => ShouldUserBeVisible(p.displayName + "")).sort((a, b) => {
        const isParticipantADominant =
            props.dominantParticipants.filter((p) => p.participantId === utils.getId(a.identifier)).length > 0;
        const isParticipantBDominant =
            props.dominantParticipants.filter((p) => p.participantId === utils.getId(b.identifier)).length > 0;
        if (isParticipantADominant && !isParticipantBDominant) {
            return -1;
        } else if (!isParticipantADominant && isParticipantBDominant) {
            return 1;
        }
        return 0;
    });
    const mainStageParticipants = participantsToLayout.slice(0, numRemoteParticipantsToRender);
    const substageParticipants = participantsToLayout.slice(numRemoteParticipantsToRender);
    // don't show the substage if its not necessary
    const isSubstageVisible = substageParticipants.length > 0;
    return (
        <Stack style={{ height: '100%' }}>
            <div
                id="video-gallery"
                className={IsCentralScreenMode() ? mediaGalletyGridDarkStyle : mediaGalleryGridStyle}
                style={{
                    gridTemplateRows: `repeat(${gridRow}, minmax(0, 1fr))`,
                    gridTemplateColumns: `repeat(${gridCol}, 1fr)`
                }}
            >
                {getMediaGalleryTilesForParticipants(mainStageParticipants, props.displayName)}
            </div>
            {isSubstageVisible && (
                <Stack horizontal className={mediaGallerySubstageStyle}>
                    {getSubstageMediaGalleryTilesForParticipants(substageParticipants)}
                </Stack>
            )}
            {isWaiting && IsCandidateMode() ? (
                <Stack.Item styles={footerStyle}>
                    <div>
                        <Label className={labelFooterStyle}>{labelConstants.WaitForInterlocutor}</Label>
                    </div>
                </Stack.Item>
            ) : (
                <div>
                </div>
            )}
        </Stack>
    );
};